import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { productQueryOptions, variantsQueryOptions } from '@/features/products';
import {
  storePricingQueryOptions,
  StoreProductPage,
  storeProductQueryOptions,
} from '@/features/store-catalog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/catalog/$storeProductId')({
  staticData: { tours: ['store-catalog.product'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const row = await context.queryClient.query({
      ...storeProductQueryOptions(params.storeId, params.storeProductId),
      staleTime: 'static',
    });
    // The page also shows the master product's own cards, read-only; without them it still opens.
    await Promise.all([
      context.queryClient
        .query({ ...productQueryOptions(row.productId), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...variantsQueryOptions(row.productId), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({
          ...storePricingQueryOptions(params.storeId, params.storeProductId),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    return { crumb: row.title ?? row.product.title };
  },
  component: StoreProductPage,
});
